import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProgressBarService {

  private totalRequestsSource = new BehaviorSubject<number>(0);
  private completedRequestsSource = new BehaviorSubject<number>(0);

  totalRequests$ = this.totalRequestsSource.asObservable();
  completedRequests$ = this.completedRequestsSource.asObservable();

  private totalRequests = 0;
  private completedRequests = 0;

  incrementTotalRequests(total:number): void {
    this.totalRequests=total;;
    this.totalRequestsSource.next(this.totalRequests);
  }

  incrementCompletedRequests(): void {
    this.completedRequests++;
    this.completedRequestsSource.next(this.completedRequests);
  }

  resetRequests(): void {
    this.totalRequests = 0;
    this.completedRequests = 0;
    this.totalRequestsSource.next(this.totalRequests);
    this.completedRequestsSource.next(this.completedRequests);
  }
}
